/**
 * @voltxampere/ui — IGBT IRG4PC50UD variant (Sprint 44-2, placeholder)
 *
 * PLACEHOLDER. Insulated-gate bipolar transistor (gate-drive +
 * BJT output composition); gerçek IGBT stamp Sprint 47+ engine
 * extension #4 ile aktif. Şu anki stamp'te `mosfet-nmos`
 * schemaType üzerinden gate-controlled drain-source davranış
 * gösterir; collector-emitter saturation voltage (V_CE(sat))
 * model yok.
 *
 * Reference: International Rectifier IRG4PC50UD — TO-247AC.
 * V_CES = 600 V, I_C = 27 A (T_C = 100°C), V_GE(th) = 4 V (typ),
 * V_CE(sat) = 1.65 V (at I_C = 27 A). Co-pack with ultrafast soft
 * recovery diode. Motor drive + UPS + welder workhorse.
 *
 * Engine zero-diff invariant honored — canonical `mosfet-nmos`
 * engine type via schemaType.
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { nmos } from "../nmos.js";
export const powerIgbtIrg4pc50ud = {
    id: "irg4pc50ud",
    nameTr: "IRG4PC50UD (IGBT 600V/27A, TO-247, placeholder)",
    nameEn: "IRG4PC50UD (IGBT 600V/27A, TO-247, placeholder)",
    shortcut: "M",
    category: "active",
    viewBox: nmos.viewBox,
    terminals: nmos.terminals,
    defaultLabel: "Q",
    defaultValue: "IRG4PC50UD",
    schemaType: "mosfet-nmos",
    defaultParams: { Vt0: 4.0, Kp: 50, Lambda: 0.01 },
    renderSVG: () => nmos.renderSVG(),
};
//# sourceMappingURL=power-igbt-irg4pc50ud.js.map